export const buildGeneralInformationRow = function (tenantDataRow, tab) {

    return {
        highlightable: true,
        isHighlighted(tabs, rowIdentifier) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
            return (inputText.trim() === 'Vacant' || inputText.trim() === 'vacant');
        },
        valueCells: [{
            type: 'text',
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            forceStatic: tab === 'proforma-rr-tab',
            hasSort: tab === 'current-rr-tab',
            code: 'RR_SUITE_CODE',
            value: tenantDataRow.RR_SUITE_CODE || '',
        }, {
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            value: tab === 'proforma-rr-tab' && tenantDataRow.PROFORMA_RR_TENANT_NAME ? tenantDataRow.PROFORMA_RR_TENANT_NAME
                       : tab === 'proforma-rr-tab' && tenantDataRow.TENANT_NAME === 'Vacant' ? 'Lease Up'
                           : (tenantDataRow.TENANT_NAME || '')
        }, {
            type: 'number',
            editable: true,
            nameClasses: 'font-gotham font-size-10',
            value: tab === 'proforma-rr-tab' && tenantDataRow.PROFORMA_RR_SQFT ? tenantDataRow.PROFORMA_RR_SQFT : (tenantDataRow.RR_SQFT || 0),
        }, { // leave ARCIMEDES_ROW_ID as the last but one
            type: 'string',
            hidden: true,
            value: tenantDataRow.ARCIMEDES_ROW_ID,
        }, { // leave TENANT_ROW_ID as the last one
            type: 'string',
            hidden: true,
            value: tenantDataRow.TENANT_ROW_ID || '0',
        },]
    };
};


export const generalInformation = {
    hasNamesColumn: false,
    rows: {},
};
